<div class="research-load-error" *ngIf="loadFailed()">
  Couldn't load this brand's research status. Reopen the drawer to retry — saving the brand is unaffected.
</div>

<div class="research-row" *ngIf="!loadFailed()">
  <span class="research-badge" [ngClass]="badge().kind" [title]="badge().title ?? ''">
    <span class="dot" aria-hidden="true"></span>{{ badge().text }}
  </span>

  <!-- The only flexible segment of the row: shrinks (clipping excess chips) instead of
       pushing the action buttons out of the drawer. -->
  <span class="chips">
    <span class="research-chip" *ngFor="let chip of chips()" [title]="chip.title">{{ chip.text }}</span>
  </span>

  <span class="actions">
    <button type="button" class="link-button" *ngIf="hasResearch()" (click)="openViewer()">View research</button>

    <!-- stopPropagation: the click that OPENS the picker (and clicks inside it) must not bubble
         to the document-level outside-close handler. -->
    <span class="run-anchor" (click)="$event.stopPropagation()"
      [title]="runActive() ? 'Research is already queued or running for this brand' : ''">
      <app-button text="Run…" [class]="runActive() ? 'primary disabled' : 'primary'" (clicked)="openPicker()"></app-button>

      <div class="research-picker" *ngIf="pickerOpen()" [class.open-up]="pickerOpensUp()"
        (keydown.escape)="onPickerEscape($event)">
        <div class="picker-title">Run brand research</div>
        <p class="picker-explain">
          AI-researches this brand across its configured channels and rebuilds the profile that
          social-metrics estimation is based on — without it the brand has no social data.
          Starts within ~10 minutes.
        </p>
        <label class="picker-label" for="research-valid-from">Estimate metrics from</label>
        <input id="research-valid-from" type="date" [formControl]="validFromControl"
          [min]="minValidFrom" [max]="maxValidFrom">
        <div class="picker-hint">
          Social metrics can only be estimated for dates after this day (earliest {{ minValidFrom }} —
          no ads data exists before). Default: 30 days back.
        </div>
        <div class="picker-actions">
          <app-button text="Cancel" class="cancel" (clicked)="closePicker()"></app-button>
          <app-button [text]="triggering() ? 'Queuing…' : 'Run research'"
            [class]="canConfirm ? 'primary' : 'primary disabled'" (clicked)="run()"></app-button>
        </div>
      </div>
    </span>
  </span>
</div>

<div class="research-trigger-error" *ngIf="triggerError() as message">{{ message }}</div>

<div class="research-poll-note" *ngIf="pollLost()">
  Live status updates paused (network trouble) — close and reopen the drawer to resume.
</div>
